/* unplugin-vue-components disabled */import { render } from "./SearchInput.vue?vue&type=template&id=cbe0d6d6&scoped=true&ts=true"
import script from "./SearchInput.vue?vue&type=script&lang=ts"
export * from "./SearchInput.vue?vue&type=script&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=cbe0d6d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe0d6d6"]])

export default __exports__